document.addEventListener("DOMContentLoaded", () => {
  const checkboxes = document.querySelectorAll('.custom-checkbox');
  if (checkboxes.length === 0) return;

  let checkedInputs = [];

  const storedCheckedInputs = JSON.parse(sessionStorage.getItem('checkedInputs'));
  if(storedCheckedInputs) {
    checkedInputs = storedCheckedInputs;
    checkedInputs.forEach(checkId => {
      const allNumbered = document.querySelectorAll(`.check_${checkId}`);
      allNumbered.forEach(numbered => {
        numbered.classList.add('checked');
      });
    });
    checkboxes.forEach(checkbox => {
      const checkId = checkbox.querySelector('input').getAttribute('data-checkbox');
      if (checkedInputs.includes(checkId)) {
        checkbox.querySelector('input').checked = true;
      }
    });
  }

  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('click', () => {
      const checkId = checkbox.querySelector('input').getAttribute('data-checkbox');

      const allNumbered = document.querySelectorAll(`.check_${checkId}`);
      allNumbered.forEach(numbered => {
        if (checkbox.querySelector('input').checked) {
          numbered.classList.add('checked');
          checkedInputs.push(checkId);
        } else {
          numbered.classList.remove('checked');
          checkedInputs = checkedInputs.filter(item => item !== checkId);
        }
      });
      sessionStorage.setItem('checkedInputs', JSON.stringify(checkedInputs));
    });
  });
});
